export default __webpack_public_path__ + "static/media/service-grp.2d1e59db.png";